<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'dialogResult',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-member-result-dialog'" title="导入结果" width="400px"
    :footer="null" @cancel="closeDialog" :closable="false" :maskClosable="false">
    <div style="padding: 20px; text-align: center">
      <div style="font-size: 16px; margin-bottom: 15px">
        模板数据共 <span style="color: #f5222d">{{ state.form.successCount + state.form.failCount }}</span> 条
      </div>
      <a-descriptions :column="1" bordered size="small">
        <a-descriptions-item label="成功">
          <span style="color: #f5222d">{{ state.form.successCount }}</span> 条
        </a-descriptions-item>
        <a-descriptions-item label="失败">
          <span style="color: #f5222d">{{ state.form.failCount }}</span> 条
        </a-descriptions-item>
      </a-descriptions>
      <div style="margin-top: 20px">
        <a-button @click="closeDialog">关闭</a-button>
        <a-button v-if="state.form.failCount > 0" type="primary" class="ml10" @click="onUploadResult">下载失败记录</a-button>
      </div>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="dialogResult">
import { reactive } from 'vue'
import { cloneDeep } from 'lodash-es'

const state = reactive({
  dialog: {
    visible: false
  },
  form: {
    failCount: 0,
    successCount: 0,
    url: ''
  }
})

const openDialog = (data: any) => {
  state.dialog.visible = true
  state.form = cloneDeep(data)
}

const closeDialog = () => {
  state.dialog.visible = false
}

const onUploadResult = () => {
  let downloadUrl = state.form.url
  const fileName = `导入失败记录_${new Date().getTime()}.xlsx`
  const separator = downloadUrl.includes('?') ? '&' : '?'
  const disposition = `attachment;filename=${encodeURIComponent(fileName)}`
  downloadUrl = `${downloadUrl}${separator}response-content-disposition=${encodeURIComponent(disposition)}`
  window.location.href = downloadUrl
}

defineExpose({
  openDialog
})
</script>

<style scoped>
.ml10 {
  margin-left: 10px;
}
</style>
